import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=54ff026b&scoped=true"
import script from "./MarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MarkdownEditor.vue?vue&type=script&lang=js"
import style0 from "./MarkdownEditor.vue?vue&type=style&index=0&id=54ff026b&prod&scoped=true&lang=css"
import style1 from "./MarkdownEditor.vue?vue&type=style&index=1&id=54ff026b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ff026b",
  null
  
)

export default component.exports